import { render, staticRenderFns } from "./MortalityDistributionLineGraph.vue?vue&type=template&id=281f4b53&"
import script from "./MortalityDistributionLineGraph.vue?vue&type=script&lang=js&"
export * from "./MortalityDistributionLineGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports